import { formatDate, formatNombre } from '@/services/general/general';
import * as tableConfig from '@/configuration/tableConfig';
import { getFournisseurFromDevis, getReferenceHavasFromDevis } from '@/services/devisAchat/devisAchatTransform';
import { ETAT_BROUILLON, ETAT_ENREGISTRE, ETAT_SANSSUITE } from '@/configuration/devisConf';

export const COLUMNS = [
  {
    field: 'code',
    label: 'listeDevisAchat.columns.code',
    searchable: true,
    searchField: 'code',
    searchType: tableConfig.FILTRE_TYPE_INPUT,
    sortable: true,
    'header-class': 'is-size-7 has-text-grid-1 py-10 px-20',
    'cell-class': 'is-size-7 has-text-default px-20 is-vcentered',
  },
  {
    field: 'orderNumeroHavas',
    format: (row) => getReferenceHavasFromDevis(row),
    label: 'listeDevisAchat.columns.referenceHavas',
    searchable: true,
    searchField: 'orderNumeroHavas',
    searchType: tableConfig.FILTRE_TYPE_INPUT,
    sortable: false,
    'header-class': 'is-size-7 has-text-grid-1 py-10 px-20',
    'cell-class': 'is-size-7 has-text-default px-20 is-vcentered',
  },
  {
    field: 'etat',
    label: 'listeDevisAchat.columns.etat',
    searchable: true,
    searchField: 'etat',
    searchType: tableConfig.FILTRE_TYPE_SELECT,
    searchOptions: [
      { value: ETAT_BROUILLON, label: 'listeDevisAchat.etat.brouillon' },
      { value: ETAT_ENREGISTRE, label: 'listeDevisAchat.etat.enregistre' },
      { value: ETAT_SANSSUITE, label: 'listeDevisAchat.etat.sansSuite' },
    ],
    sortable: true,
    'header-class': 'is-size-7 has-text-grid-1 py-10 px-20',
    'cell-class': 'is-size-7 has-text-default px-20 is-vcentered',
  },
  {
    field: 'fournisseur',
    format: (row) => getFournisseurFromDevis(row),
    label: 'listeDevisAchat.columns.fournisseur',
    searchable: true,
    searchField: 'fournisseur',
    searchType: tableConfig.FILTRE_TYPE_INPUT,
    sortable: false,
    'header-class': 'is-size-7 has-text-grid-1 py-10 px-20',
    'cell-class': 'is-size-7 has-text-default px-20 is-vcentered',
  },
  {
    field: 'dateDevisCommande',
    format: (row) => formatDate(row.dateDevisCommande),
    label: 'listeDevisAchat.columns.date',
    searchable: true,
    searchField: 'dateDevisCommande',
    searchType: tableConfig.FILTRE_TYPE_INPUT,
    sortable: true,
    'header-class': 'is-size-7 has-text-grid-1 py-10 px-20',
    'cell-class': 'is-size-7 has-text-default px-20 is-vcentered',
  },
  {
    field: 'montantHt',
    format: (row) => formatNombre(row.montantHt || 0),
    label: 'listeDevisAchat.columns.montantHt',
    searchable: true,
    searchField: 'montant',
    searchType: tableConfig.FILTRE_TYPE_INPUT,
    sortable: true,
    'header-class': 'is-size-7 has-text-grid-1 py-10 px-20',
    'cell-class': 'is-size-7 has-text-default px-20 has-text-right is-vcentered',
  },
  {
    field: 'editer',
    label: 'listeDevisAchat.columns.editer',
    searchable: false,
    sortable: false,
    action: true,
    icon: 'file-pdf',
    'header-class': 'is-size-7 has-text-grid-1 py-10 px-20 has-text-centered',
    'cell-class': 'is-size-7 has-text-default px-20 has-text-centered is-vcentered',
    centered: true,
    width: '80',
  },
  {
    field: 'envoyerEmail',
    label: 'listeDevisAchat.columns.envoyerEmail',
    searchable: false,
    sortable: false,
    action: true,
    icon: 'email',
    'header-class': 'is-size-7 has-text-grid-1 py-10 px-20 has-text-centered',
    'cell-class': 'is-size-7 has-text-default px-20 has-text-centered is-vcentered',
    centered: true,
    width: '100',
  },
];